import React, { useContext, useEffect } from 'react'
import { StyleSheet, Text, View } from 'react-native';
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'; 
import { useTranslation } from 'react-i18next';

import { shadowWhiteTxt, fontPc, fontSp } from '../../../../../style/css/CmnStyle';
import { hpContext } from '../../../HPContext';

function HpContentFeel(props) {
  const { t, i18n } = useTranslation();

  const isWide = useContext(hpContext).isWide;

  const windowDimensions = useContext(hpContext).windowDimensions;
  const windowWidth = windowDimensions.width;
  const windowHeight = windowDimensions.height;


  // useInView フックを使用して要素が表示されたことを検知
  const [ref, inView] = useInView({
    triggerOnce: true, // 一度だけトリガーする
    rootMargin: '-100px', // 表示領域に対してどれだけ外側に存在するかを指定
  });


  // 表示文章(↓が改行になる)
  const words = `
  ${t('top.feel.line1')}↓
  ↓
  ${t('top.feel.line2')}↓
  ↓
  ${t('top.feel.line3')}↓
  ↓
  ${t('top.feel.line4')}
  `;
  const word = words.split("")

  const textanimate = word.map((word, index) => {
    return (
        <>
          {word == '↓'?
            <br />
          :
            <motion.div
                key={index}
                initial={{ opacity: 0, display: 'inline-block'}}
                animate={{ opacity: 1}}
                transition={{ duration: 0.3, delay: index * 0.03 }}
            >
              {word}
            </motion.div>
          }
        </>
    )
  })


  const styles = StyleSheet.create({
    container: {
      flexDirection: 'row',
      backgroundColor: 'transparete',
      justifyContent: 'center',
      paddingHorizontal: isWide? windowWidth*0.15 : 20,
      paddingBottom: windowHeight*0.1,
    },
    content: {
      fontSize: isWide? fontPc : fontSp,
    },
  });


  return (
    <View id='feel' ref={ref} style={styles.container}>
      {inView&&
        <Text style={[shadowWhiteTxt, styles.content]}>
          {textanimate}
        </Text>
      }
    </View>
  );
}

export default HpContentFeel;
